<template>
  <v-container fluid full-height grit-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-2"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="financialYearName"
                label="Financial Year Name"
                type="text"
                class="mr-2"
                v-model="queryParams.financialYearName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="financeSettingList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.financialYearName }}</td>
              <td>{{ props.item.startMonth }}</td>
              <td>{{ props.item.endMonth }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { financeSettingService } from "../../services/finance-setting-service";
export default {
  name: "FinanceSettingList",
  data: () => ({
    showFilters: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Finance Setting",
        disabled: true,
      },
    ],
    queryParams: {
      code: "",
      financialYearName: "",
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    headers: [
      { text: "Action", sortable: false },
      { text: "Code", align: "left", value: "code" },
      {
        text: "Financial Year Name",
        align: "left",
        value: "financialYearName",
      },
      { text: "Start Month", align: "left", value: "startMonth" },
      { text: "End Month", align: "left", value: "endMonth" },
      { text: "Description", align: "left", value: "description" },
      { text: "Updated Date", align: "left", value: "updatedDate" },
      { text: "Updated By", align: "left", value: "updatedBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    financeSettingList: [],
    totalRows: 0,
    showListLoading: false,
  }),
  created() {
    this.getFinanceSettingList();
  },
  watch: {
    pagination: {
      handler() {
        this.getFinanceSettingList();
      },
      deep: true,
    },
  },

  methods: {
    onRegister() {
      this.$router.push("/finance-setting/new");
    },
    getFinanceSettingList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      financeSettingService
        .getAllFinanceSettingList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.financeSettingList = res.data.financeSettingDTOs;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onEdit(financeSetting) {
      this.$router.push("/finance-setting/" + financeSetting.id);
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "finance-settings",
        query: this.queryParams,
      });
      this.getFinanceSettingList();
    },
  },
};
</script>
